import Types from "./Types";

export const loginUserAction = (formData) => ({
  type: Types.LOGIN_USER,
  payload: formData,
});

export const loginUserSuccessAction = (user, token) => ({
  type: Types.LOGIN_USER_SUCCESS,
  payload: { user, token },
});

export const ForgetpasswordAction = (formData) => ({
  type: Types.FORGET_PASSWORD,
  payload: formData,
});

export const ForgetpasswordSuccessAction = (payload) => ({
  type: Types.FORGET_PASSWORD_SUCCESS,
  payload,
});

export const ResetpasswordAction = (formData) => ({
  type: Types.RESET_PASSWORD,
  payload: formData,
});

export const ResetpasswordSuccessAction = (payload) => ({
  type: Types.RESET_PASSWORD_SUCCESS,
  payload,
});

export const forgetpasswordOtpUserAction = (formData) => ({
  type: Types.FORGET_PASSWORD_OTP_USER,
  payload: formData,
});

export const forgetpasswordOtpUserSuccessAction = (payload) => ({
  type: Types.FORGET_PASSWORD_OTP_USER_SUCCESS,
  payload,
});
export const registerUserAction = (formData) => ({
  type: Types.REGISTER_USER,
  payload: formData,
});

export const registerUserSuccessAction = (payload) => ({
  type: Types.REGISTER_USER_SUCCESS,
  payload,
});

export const otpUserAction = (formData) => ({
  type: Types.OTP_USER,
  payload: formData,
});

export const otpUserSuccessAction = (user, token) => ({
  type: Types.OTP_USER_SUCCESS,
  payload: { user, token },
});

export const resendOtpUserAction = (formData) => ({
  type: Types.RESEND_OTP_USER,
  payload: formData,
});

export const resendOtpUserSuccessAction = (user, token) => ({
  type: Types.RESEND_OTP_USER_SUCCESS,
  payload: { user, token },
});

export const userVoucherAction = (formData) => ({
  type: Types.USER_VOUCHER,
  payload: formData,
});

export const userVoucherSuccessAction = (user, token) => ({
  type: Types.USER_VOUCHER_SUCCESS,
  payload: { user, token },
});

export const logoutUserAction = () => ({
  type: Types.LOGOUT_USER,
});

export const logoutUserSuccessAction = () => ({
  type: Types.LOGOUT_USER_SUCCESS,
});

export const setAuthIsLoadingAction = (isLoading) => ({
  type: Types.SET_AUTH_IS_LOADING,
  payload: isLoading,
});

export const getSystemGovernmentRequest = (body) => ({
  type: Types.GET_SYSTEM_GOVERNMENT_REQUEST,
  payload: body,
});

export const getSystemGovernmentSuccess = (data) => ({
  type: Types.GET_SYSTEM_GOVERNMENT_SUCCESS,
  payload: data,
});

export const getSystemGovernmentFail = () => ({
  type: Types.GET_SYSTEM_GOVERNMENT_FAIL,
});

export const getSystemRegionRequest = (body) => ({
  type: Types.GET_SYSTEM_REGION_REQUEST,
  payload: body,
});

export const getSystemRegionSuccess = (data) => ({
  type: Types.GET_SYSTEM_REGION_SUCCESS,
  payload: data,
});

export const getSystemRegionFail = () => ({
  type: Types.GET_SYSTEM_REGION_FAIL,
});

export const getSystemGradesRequest = (body) => ({
  type: Types.GET_SYSTEM_GRADES_REQUEST,
  payload: body,
});

export const getSystemGradesSuccess = (data) => ({
  type: Types.GET_SYSTEM_GRADES_SUCCESS,
  payload: data,
});

export const getSystemGradesFail = () => ({
  type: Types.GET_SYSTEM_GRADES_FAIL,
});

export const getSystemMajorsRequest = (body) => ({
  type: Types.GET_SYSTEM_MAJORS_REQUEST,
  payload: body,
});
export const getSystemMajorsSuccess = (data) => ({
  type: Types.GET_SYSTEM_MAJORS_SUCCESS,
  payload: data,
});

export const getSystemMajorsFail = () => ({
  type: Types.GET_SYSTEM_MAJORS_FAIL,
});
